// icons
import {
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack, Typography
} from '@mui/material';
// @mui
import { styled } from '@mui/material/styles';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form/dist/types';
import { ServiceProps } from 'src/@types/service';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(5),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));

type Props = {
  form: UseFormReturn;
  services: ServiceProps[];
};

type OptionStyleProps = {
  selected: boolean;
};

const SelectStyle = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<OptionStyleProps>(({ selected, theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  transition: theme.transitions.create('box-shadow'),
  borderRadius: Number(theme.shape.borderRadius) * 1.25,
  ...(selected && {
    boxShadow: theme.customShadows.z24,
  }),
}));

// ----------------------------------------------------------------------

export default function FormService({ services, form }: Props) {
  const {
    register,
    setValue,
    formState: { errors },
  } = form;
  const { query } = useRouter();

  const [selected, setSelected] = useState(false);

  const [active, setActive] = useState('');

  useEffect(() => {
    if (typeof query.service === 'string') {
      setValue('service', query.service);
      setActive(query.service);
    }
  }, [query, setValue]);

  return (
    <RootStyle>
      <Stack spacing={2} direction="row" alignItems="center" sx={{ mb: 5 }}>
        <Chip label="1" />
        <Typography variant="h5">Velg tjeneste</Typography>
      </Stack>

      <Stack spacing={2.5}>
        <div>
          <SelectStyle
            selected={selected}
            onMouseOver={() => setSelected(true)}
            onMouseOut={() => setSelected(false)}
          >
            <FormControl fullWidth>
              <InputLabel>Velg tjeneste*</InputLabel>
              <Select
                value={active}
                label="Velg tjeneste*"
                defaultValue={active}
                error={!!errors.service}
                {...register('service')}
              >
                {services?.map((service: ServiceProps) => (
                  <MenuItem
                    onClick={() => setActive(service.slug.current)}
                    key={service.slug.current}
                    value={service.slug.current}
                  >
                    {service.title}
                  </MenuItem>
                ))}
                <MenuItem onClick={() => setActive('other')} value="other">
                  Annet
                </MenuItem>
              </Select>
            </FormControl>
          </SelectStyle>
          {!!errors.service && (
            <Typography variant="caption" color="error">
              {errors.service.message}
            </Typography>
          )}
        </div>
      </Stack>
    </RootStyle>
  );
}
